var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.editing
      ? _c(
          "p",
          {
            staticClass:
              "segment-name regular bold text-gray mr-2 ml-0 my-0 w-100",
            attrs: { title: _vm.segmentName },
            on: {
              dblclick: function ($event) {
                return _vm.setEditing(true, _vm.segmentName)
              },
            },
          },
          [
            _vm._v("\n    " + _vm._s(_vm.segmentName) + "\n    "),
            _vm.isCurrentTab
              ? _c(
                  "span",
                  {
                    staticClass: "clickable edit-name pl-1",
                    on: {
                      click: function ($event) {
                        return _vm.setEditing(true, _vm.segmentName)
                      },
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-pencil p-1",
                      attrs: { "aria-hidden": "true" },
                    }),
                  ]
                )
              : _vm._e(),
          ]
        )
      : _c("div", { staticClass: "segment-name position-relative" }, [
          _c("div", { staticClass: "edit-name-wrapper" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newName,
                  expression: "newName",
                },
              ],
              ref: "newLabelInput",
              staticClass: "edit-name-input",
              attrs: { type: "text", placeholder: "Edit name", name: "label" },
              domProps: { value: _vm.newName },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.newName = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "save-name btn h-100 p-1",
                on: { click: _vm.handleChangeName },
              },
              [
                _c("i", {
                  staticClass: "fa fa-check",
                  attrs: { "aria-hidden": "true" },
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "close-edit btn h-100 p-1",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.setEditing(false)
                  },
                },
              },
              [
                _c("i", {
                  staticClass: "fa fa-ban",
                  attrs: { "aria-hidden": "true" },
                }),
              ]
            ),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }